"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 246,
    },
};
var description = 'You can style it as well.';
var code = "import React from 'react';\nimport { Card } from 'jsc-react-ui';\n\nconst style = {\n  width: 246,\n};\n\nconst CardExample = () => (\n  <Card style={style} title=\"Thoughts\" color=\"#3498db\">\n    Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor,\n    ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum.\n  </Card>\n);";
exports.StylingExampleCard = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.Card, { style: componentStyle.base, title: "Thoughts", color: '#3498db' }, "Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor, ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum."))); };
exports.StylingExampleCard.displayName = 'StylingExampleCard';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/StylingExampleCard.tsx
// module id = 643
// module chunks = 0